var chunkMapping = {
	"51": [
		8051
	],
	"300": [
		8300
	],
	"376": [
		8376
	],
	"415": [
		2415
	]
};
var idToExternalAndNameMapping = {
	"2415": [
		"default",
		"./module",
		7852
	],
	"8051": [
		"default",
		"./module",
		4464
	],
	"8300": [
		"default",
		"./module",
		1040
	],
	"8376": [
		"default",
		"./module",
		6502
	]
};
var idToRemoteMap = {
	"2415": [
		{
			"externalType": "script",
			"name": "admin"
		}
	],
	"8051": [
		{
			"externalType": "script",
			"name": "surveys"
		}
	],
	"8300": [
		{
			"externalType": "script",
			"name": "journey"
		}
	],
	"8376": [
		{
			"externalType": "script",
			"name": "audience"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"2415": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 7852,
		"remoteName": "admin"
	},
	"8051": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 4464,
		"remoteName": "surveys"
	},
	"8300": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 1040,
		"remoteName": "journey"
	},
	"8376": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 6502,
		"remoteName": "audience"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}